export const BASE_FPL_URL: string = `${process.env.REACT_APP_API_URL}/fpl`

export const BASE_ENTRIES_URL: string = `${BASE_FPL_URL}/entry`

export const BASE_API_URL: string = process.env.REACT_APP_API_URL ?? ''
